import { atom } from 'recoil'

export const modalBeeSavedRowMetadataState = atom({
  key: 'modalBeeSavedRowMetadataState',
  default: {
    show: false,
    onConfirm: undefined,
    onCancel: undefined,
    resolveMetadata: false,
    row: undefined,
    metadata: {
      name: undefined
    }
  }
})
